import { memo, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import UIAlert from 'UIComponents/alert/UIAlert';

// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { isEmailCMF
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getFromAddress, getFromName, getIsMemberOfForwardedSubthread, getStatus, getIsForward, getTimestamp
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import { getCommonMessageSenderId } from 'conversations-message-history/common-message-format/operators/getCommonMessageSenderId';
// @ts-expect-error module not typed
import { getCommonMessageSenderType } from 'conversations-message-history/common-message-format/operators/getCommonMessageSenderType';
// @ts-expect-error module not typed
import { getSenderIdOrVid } from 'conversations-message-history/common-message-format/operators/getSenderIdOrVid';
import { getContentAttachments, getMessageDirection, getGenericChannelId, getSingleRecipientTypeFromMessage, getSingleRecipientIdFromMessage, getAttachments, getSenders, getSenderDeliveryIdentifierValue } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { VISITOR as VISITOR_SENDER } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { List as ImmutableList, Set as ImmutableSet } from 'immutable';
import PropTypes from 'prop-types';
import TimelineCallMetadata from 'conversations-calling-message/timeline-call-metadata/components/TimelineCallMetadata';
import NoContentLabel from 'conversations-message-history/atoms/NoContentLabel';
import AttachmentsFooter from '../attachments/AttachmentsFooter';
import InlineAttachments from '../attachments/InlineAttachments';
import { getFilteredAttachments, hasRenderableAttachments
// @ts-expect-error module not typed
} from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
import { getLocationAttachment } from 'conversations-message-history/attachments/operators/locationAttachmentGetters';
import { getContactAttachments } from 'conversations-message-history/attachments/operators/contactAttachmentGetters';
import { getUnsupportedContentAttachment } from 'conversations-message-history/attachments/operators/unsupportedContentAttachmentGetters';
// @ts-expect-error module not typed
import { getCallMetadataAttachment } from 'conversations-message-history/call/operators/callMetadataAttachmentGetters';
import { LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import { AGENT as DEFAULT, VISITOR } from 'conversations-message-history/constants/messageUses';
import { CALLING_GENERIC_CHANNEL_ID, WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
// @ts-expect-error module not typed
import { getMessageId } from 'conversations-message-history/message-history/operators/getMessageId';
// @ts-expect-error module not typed
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
// @ts-expect-error module not typed
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
// @ts-expect-error module not typed
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
// @ts-expect-error module not typed
import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { findLegacyRecipient } from 'conversations-message-history/legacy-recipients/operators/findLegacyRecipient';
import { getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
import { getData } from 'conversations-async-data/async-data/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { isRecipientLoading } from 'conversations-message-history/legacy-recipients/operators/isRecipientLoading';
// @ts-expect-error module not typed
import { senderEmailDoesNotMatchVisitor } from 'conversations-message-history/senders/operators/senderEmailDoesNotMatchVisitor';
import Sender from 'conversations-message-history/senders/records/Sender';
import CommonMessageHeaderContent from '../common-message-header/CommonMessageHeaderContent';
import MessageHeaderTimestamp from '../common-message-header/MessageHeaderTimestamp';
// @ts-expect-error module not typed
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
// @ts-expect-error module not typed
import { hasImageContent } from 'conversations-message-history/web/common-message/operators/hasImageContent';
import CommonMessageContent from './CommonMessageContent';
import getMessageIdFromLocation from './operators/getMessageIdFromLocation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import WorkflowGeneratedUserHeaderAttachment from '../workflow-generated-user-message/components/WorkflowGeneratedUserHeaderAttachment';
import { getMessageHeaderAttachment } from 'conversations-message-history/attachments/operators/headerAttachmentGetters';
import { getQuickRepliesAttachment } from 'conversations-message-history/attachments/operators/quickRepliesAttachmentGetters';
import QuickRepliesAttachment from '../attachments/QuickRepliesAttachment';
import { INCOMING } from 'conversations-message-history/common-message-format/constants/messageDirections';
import { QUARANTINED } from 'conversations-message-history/common-message-format/constants/statusTypes';
import QuarantinedMessageAlert from './QuarantinedMessageAlert';
import DeliveryStatusFooter from '../delivery-status/DeliveryStatusFooter';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import DirectReplyOriginalMessagePreview from '../v2/message-data/direct-reply/DirectReplyOriginalMessagePreview';
import styled from 'styled-components';
import { CallStatusMessage } from '../call-status/CallStatusMessage';
import { getAsyncAttachmentState } from '../attachments/operators/getAsyncAttachmentState';
import { ColorIndicator } from './ColorIndicator';
import { ForwardSubject } from './ForwardSubject';
import { CommonMessageAvatar } from './CommonMessageAvatar';
import { useContainerQuery } from './useContainerQuery';
import HiddenMessage from './HiddenMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ACTIONS_COLLAPSE_WIDTH = 600;
export const ICON_MINIMIZE_WIDTH = 500;
const StyledHeaderContainer = styled.div.withConfig({
  displayName: "CommonMessage__StyledHeaderContainer",
  componentId: "q813iz-0"
})(["width:100%;"]);
export const StyledContentColumn = styled.div.withConfig({
  displayName: "CommonMessage__StyledContentColumn",
  componentId: "q813iz-1"
})(["display:inline-flex;flex-direction:column;align-items:center;flex:1;padding:", "px;margin-left:0px;overflow-x:auto;"], ({
  disablePadding
}) => disablePadding ? '0' : '8');
export const PrimaryMessageBody = styled.div.withConfig({
  displayName: "CommonMessage__PrimaryMessageBody",
  componentId: "q813iz-2"
})(["display:flex;flex-direction:row;"]);
const CommonMessage = props => {
  const [breakpointResults, commonMessageContainerRef] = useContainerQuery([ACTIONS_COLLAPSE_WIDTH, ICON_MINIMIZE_WIDTH]);
  const isForwarded = isEmailCMF(props.message) && getIsMemberOfForwardedSubthread(props.message);
  const renderQuickReplies = () => {
    const {
      message
    } = props;
    const messageDirection = getMessageDirection(message);
    const quickRepliesAttachment = getQuickRepliesAttachment(message);
    if (!quickRepliesAttachment || messageDirection === INCOMING) {
      return null;
    }
    return /*#__PURE__*/_jsx(QuickRepliesAttachment, {
      quickRepliesAttachment: quickRepliesAttachment
    });
  };
  const renderMessageHeaderAttachment = () => {
    const {
      fileAttachments,
      message
    } = props;
    const headerAttachment = getMessageHeaderAttachment(message);
    const genericChannelId = getGenericChannelId(message);
    if (!headerAttachment) {
      return null;
    }
    return /*#__PURE__*/_jsx(WorkflowGeneratedUserHeaderAttachment, {
      headerAttachment: headerAttachment,
      fileAttachments: fileAttachments,
      genericChannelId: genericChannelId
    });
  };
  const renderQuarantinedMessage = () => {
    return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      children: /*#__PURE__*/_jsx(QuarantinedMessageAlert, {})
    });
  };
  const renderHiddenMessage = () => {
    const {
      hiddenMessage
    } = props;
    return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      children: hiddenMessage || /*#__PURE__*/_jsx(HiddenMessage, {})
    });
  };
  const renderMessageContent = () => {
    const {
      fetchReplies,
      handleFetchImageProcessingStatus,
      message,
      messageReplyIsLoading,
      numberOfProcessingImages,
      plainTextMode = false,
      shouldDisplayBanner
    } = props;
    const headerAttachment = renderMessageHeaderAttachment();
    const quickReplies = renderQuickReplies();
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [headerAttachment, /*#__PURE__*/_jsx(CommonMessageContent, {
        fetchReplies: fetchReplies,
        message: message,
        messageReplyIsLoading: messageReplyIsLoading,
        plainTextMode: plainTextMode,
        handleFetchImageProcessingStatus: handleFetchImageProcessingStatus,
        shouldDisplayBanner: shouldDisplayBanner,
        numberOfProcessingImages: numberOfProcessingImages
      }), quickReplies]
    });
  };
  const renderMessageSection = () => {
    const {
      directReplyState,
      fileAttachments,
      hiddenBy,
      message,
      positionDescriptors,
      lastMessageId
    } = props;
    const genericChannelId = getGenericChannelId(message);
    if (hiddenBy) {
      const {
        actorId
      } = hiddenBy;
      const hasSystemActorType = actorId === null || actorId === void 0 ? void 0 : actorId.startsWith('S');
      if (actorId && !hasSystemActorType) {
        return renderHiddenMessage();
      }
    }

    // TODO - Make quarantined message generic once there's
    // an easy way to grab a friendly name based off of ID
    if (genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID && getStatus(message) === QUARANTINED) {
      return renderQuarantinedMessage();
    }
    const shouldRenderContent = hasTextContent(message) || hasImageContent(message);

    //remove header attachment from rest of the file attachments
    const contentAttachments = fileAttachments && fileAttachments.size ? getContentAttachments(message, fileAttachments) : ImmutableList();
    const shouldRenderInlineAttachments = !isEmailCMF(message) && hasRenderableAttachments(contentAttachments);
    if (!shouldRenderInlineAttachments && !shouldRenderContent) return null;
    const renderableAttachments = shouldRenderInlineAttachments && getFilteredAttachments({
      fileAttachments: contentAttachments,
      canRender: true
    });
    const isLast = positionDescriptors.includes(LAST) || lastMessageId === getMessageId(message);
    return /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
      canExpand: true,
      isLastMessage: isLast,
      children: [directReplyState && /*#__PURE__*/_jsx(DirectReplyOriginalMessagePreview, {
        directReplyState: directReplyState
      }), renderMessageContent(), shouldRenderInlineAttachments && /*#__PURE__*/_jsx(InlineAttachments, {
        fileAttachments: renderableAttachments,
        genericChannelId: genericChannelId
      })]
    });
  };
  const renderCallMetadataAttachmentFooterSection = () => {
    const {
      message,
      ungatedForNextBestActions
    } = props;
    const callMetadata = getCallMetadataAttachment(message);
    if (callMetadata) {
      return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
        children: /*#__PURE__*/_jsx(TimelineCallMetadata, {
          ungatedForNextBestActions: !!ungatedForNextBestActions,
          message: message,
          callMetadata: callMetadata
        })
      });
    }
    return null;
  };
  const renderAttachmentsFooterSection = () => {
    const {
      fileAttachments,
      message
    } = props;
    const locationMetadata = getLocationAttachment(message);
    const contactsMetadata = getContactAttachments(message);
    const unsupportedContent = getUnsupportedContentAttachment(message);

    //remove header attachment from rest of the file attachments
    const contentAttachments = fileAttachments && fileAttachments.size ? getContentAttachments(message, fileAttachments) : ImmutableList();
    const attachments = isEmailCMF(message) ? fileAttachments : getFilteredAttachments({
      fileAttachments: contentAttachments,
      canRender: false
    });
    const genericChannelId = getGenericChannelId(message);
    const shouldRenderAttachments = Boolean(locationMetadata) || Boolean(contactsMetadata) || Boolean(unsupportedContent) || attachments && attachments.size > 0;
    if (!shouldRenderAttachments) return null;
    return /*#__PURE__*/_jsx(AttachmentsFooter, {
      fileAttachments: attachments,
      locationMetadata: locationMetadata || undefined,
      contactsMetadata: contactsMetadata || undefined,
      unsupportedContent: unsupportedContent || undefined,
      genericChannelId: genericChannelId
    });
  };
  const renderHeaderContent = () => {
    const {
      message,
      senders,
      senderName,
      vid,
      legacyRecipients,
      channelName,
      messageActions
    } = props;
    const senderType = getCommonMessageSenderType({
      message
    });
    const senderId = getCommonMessageSenderId({
      message
    });
    const recipientType = getSingleRecipientTypeFromMessage(message);
    const recipientId = getSingleRecipientIdFromMessage(message);
    const updatedSenderId = getSenderIdOrVid({
      message,
      vid,
      senderId
    });
    const asyncSender = findSender(updatedSenderId, senderType, senders);
    const isLoadingSender = isSenderLoading(asyncSender);
    let sender = getData(asyncSender);
    const asyncRecipient = recipientId && recipientType && legacyRecipients && findLegacyRecipient(recipientId, recipientType, legacyRecipients);
    const isLoadingRecipient = isRecipientLoading(asyncRecipient);
    const recipient = getData(asyncRecipient) || undefined;
    const fromAddress = getFromAddress(message);
    if (!sender || senderEmailDoesNotMatchVisitor({
      sender,
      message
    }) ||
    // If sender object for the visitor exists but first name and last name does not exists then use
    // from address for displaying name in email header
    fromAddress && !getFirstName(sender) && !getLastName(sender)) {
      sender = Sender({
        senderType,
        firstName: getFromName(message),
        email: fromAddress || null
      });
    }
    const messageTimestamp = getTimestamp(message);
    return /*#__PURE__*/_jsx(StyledHeaderContainer, {
      children: /*#__PURE__*/_jsxs(PrimaryMessageHeaderContent, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "display-inline justify-start",
          children: /*#__PURE__*/_jsx(CommonMessageHeaderContent, {
            isSenderLoading: isLoadingSender,
            sender: sender,
            senderName: senderName,
            isRecipientLoading: isLoadingRecipient,
            recipient: recipient,
            message: message,
            isForwarded: isForwarded,
            channelName: channelName,
            iconShouldMinimize: breakpointResults[ICON_MINIMIZE_WIDTH]
          })
        }), /*#__PURE__*/_jsx(MessageHeaderTimestamp, {
          timestamp: messageTimestamp
        }), messageActions]
      })
    });
  };
  const renderMessageFooter = () => {
    const {
      message,
      positionDescriptors,
      visitorLastReadTimestamp
    } = props;
    const callMetadata = getCallMetadataAttachment(message);
    const senderType = getCommonMessageSenderType({
      message
    });
    if (callMetadata || senderType === VISITOR_SENDER) {
      return null;
    }
    return /*#__PURE__*/_jsx(DeliveryStatusFooter, {
      timestamp: message.timestamp,
      status: message.status,
      positionDescriptors: positionDescriptors,
      visitorLastReadTimestamp: visitorLastReadTimestamp || null
    });
  };
  const renderAttachmentDeletedAlert = () => {
    return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
      canExpand: false,
      children: /*#__PURE__*/_jsx(UIAlert, {
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.common-message.attachmentDeletedMessage"
        })
      })
    });
  };
  const {
    message,
    positionDescriptors,
    highlight,
    indexedAsyncFileAttachments,
    isHovered = false,
    fileAttachmentsForThread,
    onClickAvatar,
    presentSenderLocators,
    senders,
    vid
  } = props;
  const senderType = getCommonMessageSenderType({
    message
  });
  const isFromVisitor = senderType === VISITOR_SENDER;
  const use = isFromVisitor ? VISITOR : DEFAULT;
  const asyncAttachmentState = fileAttachmentsForThread && indexedAsyncFileAttachments && getAsyncAttachmentState({
    message,
    loadedFileAttachments: fileAttachmentsForThread,
    indexedAsyncFileAttachments
  });
  const isLoadingAttachment = asyncAttachmentState && asyncAttachmentState.isLoadingAttachment;
  const isMissingAttachment = asyncAttachmentState && asyncAttachmentState.isMissingAttachment;
  const messageSection = renderMessageSection();
  const callMetadataAttachmentSection = renderCallMetadataAttachmentFooterSection();
  const messageContent = callMetadataAttachmentSection || messageSection;
  const attachmentsFooterSection = renderAttachmentsFooterSection();
  const location = useLocation();
  const deepLinkedMessageId = getMessageIdFromLocation(location);
  const isMessageDeepLinked = deepLinkedMessageId === message.id;
  const [clearDeepLinkHighlight, setClearDeepLinkHighlight] = useState(false);
  const shouldHighlightDeepLinkedMessage = isMessageDeepLinked && !clearDeepLinkHighlight;
  const shouldHighlight = highlight || shouldHighlightDeepLinkedMessage;

  // TODO: improve a11y by making the container focusable, see this issue: https://git.hubteam.com/HubSpot/conversations-inbox-message-history/issues/1884
  useEffect(() => {
    const onClickRemoveHighlight = () => setClearDeepLinkHighlight(true);
    if (isMessageDeepLinked) {
      // timeout is needed to ensure the click event is not immediately triggered
      setTimeout(() => window.addEventListener('click', onClickRemoveHighlight, {
        once: true
      }));
    }
    return () => window.removeEventListener('click', onClickRemoveHighlight);
  }, [isMessageDeepLinked]);

  // TODO: clean up inbound call received message code once BE refactors call status messages
  const genericChannelId = getGenericChannelId(message);
  const messageDirection = getMessageDirection(message);
  const attachments = getAttachments(message);
  const sender = getSenders(message).first();
  const senderEmail = getSenderDeliveryIdentifierValue(sender);
  // the welcome message will always be from the sample contact Maria Johnson with email 'emailmaria@hubspot.com'
  const sampleContactEmail = 'emailmaria@hubspot.com';
  const isInboundCallReceivedMessage = genericChannelId === CALLING_GENERIC_CHANNEL_ID && messageDirection === INCOMING && attachments.size === 0 && senderEmail !== sampleContactEmail;
  const isFwdItself = isEmailCMF(message) && getIsForward(message);
  const headerContent = renderHeaderContent();
  return isInboundCallReceivedMessage ? /*#__PURE__*/_jsx(CallStatusMessage, {
    message: message
  }) : /*#__PURE__*/_jsxs(PrimaryMessage, {
    "data-test-id": `primary-message-${use}`,
    "data-debug-common-message-mismatch": true,
    positionDescriptors: positionDescriptors,
    use: DEFAULT,
    ref: commonMessageContainerRef,
    children: [/*#__PURE__*/_jsxs(PrimaryMessageContent, {
      highlight: shouldHighlight,
      isHovered: isHovered,
      children: [isForwarded ? /*#__PURE__*/_jsx(ColorIndicator, {
        forwarded: isForwarded,
        "data-test-id": "forwarded-indicator-bar"
      }) : isFromVisitor ? /*#__PURE__*/_jsx(ColorIndicator, {
        "data-test-id": "visitor-indicator-bar"
      }) : null, isFwdItself ? /*#__PURE__*/_jsx(ForwardSubject, {
        message: message
      }) : null, /*#__PURE__*/_jsxs(PrimaryMessageBody, {
        children: [/*#__PURE__*/_jsx(CommonMessageAvatar, {
          message: message,
          onClickAvatar: onClickAvatar,
          presentSenderLocators: presentSenderLocators,
          senders: senders,
          vid: vid
        }), /*#__PURE__*/_jsxs(StyledContentColumn, {
          disablePadding: !headerContent && !messageContent,
          children: [headerContent, messageContent, isMissingAttachment && renderAttachmentDeletedAlert(), !messageSection && !attachmentsFooterSection && !isLoadingAttachment && /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
            children: /*#__PURE__*/_jsx(NoContentLabel, {})
          })]
        })]
      }), attachmentsFooterSection]
    }), renderMessageFooter()]
  });
};
CommonMessage.displayName = 'CommonMessage';
CommonMessage.propTypes = {
  channelName: PropTypes.string,
  directReplyState: PropTypes.any,
  // refer to the TS type instead
  fetchReplies: PropTypes.func,
  // @ts-expect-error this is correct, typescript is displeased by it.  propTypes will be removed once all CommonMessage consumers are ts
  fileAttachments: PropTypes.instanceOf(ImmutableList),
  fileAttachmentsForThread: PropTypes.any,
  // refer to the TS type instead
  handleFetchImageProcessingStatus: PropTypes.func,
  hiddenBy: PropTypes.shape({
    actorId: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired
  }),
  hiddenMessage: PropTypes.node,
  highlight: PropTypes.bool,
  indexedAsyncFileAttachments: PropTypes.any,
  // refer to the TS type instead
  isHovered: PropTypes.bool,
  lastMessageId: PropTypes.string,
  legacyRecipients: PropTypes.any,
  // refer to the TS type instead
  message: RecordPropType('CommonMessage').isRequired,
  messageActions: PropTypes.node,
  messageReplyIsLoading: PropTypes.bool,
  numberOfProcessingImages: PropTypes.number,
  onClickAvatar: PropTypes.func,
  onClickToForward: PropTypes.func,
  onClickToReply: PropTypes.func,
  onClickToReplyAll: PropTypes.func,
  plainTextMode: PropTypes.bool.isRequired,
  positionDescriptors: PositionDescriptors.isRequired,
  // @ts-expect-error this is correct, typescript is displeased by it.  propTypes will be removed once all CommonMessage consumers are ts
  presentSenderLocators: PropTypes.instanceOf(ImmutableSet).isRequired,
  senderName: PropTypes.node,
  senders: SenderMap,
  shouldDisplayBanner: PropTypes.bool,
  threadId: PropTypes.any,
  // refer to the TS type instead
  ungatedForNextBestActions: PropTypes.bool,
  ungatedForReplyToAllMessages: PropTypes.bool,
  vid: PropTypes.number,
  visitorLastReadTimestamp: PropTypes.number
};
CommonMessage.defaultProps = {
  isHovered: false,
  plainTextMode: false,
  presentSenderLocators: ImmutableSet()
};
export default /*#__PURE__*/memo(CommonMessage);